import React, { useContext, useState } from 'react';
import twMerge from 'utilities/src/twMerge';
import { usePathname } from 'next/navigation';
import LinkItem from './_LinkItem';
import getRelativePath from './_getRelativePath';
import ThemeContext from '../_themeContext';

interface Props {
  links: { label: string; href: string }[];
  index: number;
}

export default function LinkGroup({ links, index }: Props) {
  const activeItem = usePathname();
  const { theme } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <LinkItem
        onClick={() => setIsOpen((prev) => !prev)}
        areNestedLinksOpen={isOpen}
        href={links[0].href}
        label={links[0].label}
        isActive={getRelativePath(links[0].href) === activeItem}
        index={index}
        hasNestedLinks={links.length > 1}
        className={twMerge({ 'mdS:hover:no-underline hover:underline': links.length === 1 })}
      />
      {links.length > 1 && (
        <div className="mdS:absolute mdS:invisible group-hover:mdS:visible left-0 top-full flex w-fit flex-col">
          <div className="mdS:block hidden h-2 bg-transparent" />
          <div
            className={twMerge('mdS:contents grid grid-rows-[minmax(0,_0fr)] transition-[grid-template-rows]', {
              'grid-rows-[minmax(0,_1fr)]': isOpen,
            })}
          >
            <ul
              className={twMerge(
                'mdS:shadow-lv3 mdS:bg-site-neutrals-50 site-paragraph-m mdS:pl-0 mdS:py-3 flex h-fit w-full min-w-[13.5rem] flex-col overflow-hidden rounded-lg pl-3 transition-[background-color] duration-300',
                { 'mdS:bg-site-neutrals-900': theme === 'dark' },
              )}
            >
              {links.slice(1).map((link) => (
                <li key={link.label}>
                  <LinkItem
                    key={link.label}
                    href={link.href}
                    label={link.label}
                    isActive={getRelativePath(link.href) === activeItem}
                    className="mdS:text-site-neutrals-600 hover:underline"
                    contentClassName="py-2.5"
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
